export const FETCH_REPORT_GROUPS = 'FETCH_REPORT_GROUPS';
export const GET_REPORTS = 'GET_REPORTS';
export const FETCH_REPORTS = 'FETCH_REPORTS';
export const FETCH_REPORT_DETAILS = 'FETCH_REPORT_DETAILS';
export const DISPLAY_REPORT = 'DISPLAY_REPORT';
